import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import APIUtil from 'util/APIUtil';

/**
 * Scans through the schemas of a structured table, returning the first process-related schema ID in the
 * list. Although there shouldn't be more than one, we return the first matching schema.
 */
export default function findProcessRelatedSchemaId(schemaIds: Array<string>): string | null {
  const processRelatedSchemaIds = schemaIds.filter((schemaId) => {
    const modelType = APIUtil.apiIdToMaybeType(schemaId);
    return (
      modelType != null &&
      [
        ModelTypeConstants.PROCESS_TASK_SCHEMA,
        ModelTypeConstants.PROCESS_OUTPUT_SCHEMA,
        ModelTypeConstants.PROCESS_SCHEMA,
      ].includes(modelType)
    );
  });
  const {length} = processRelatedSchemaIds;
  assert(length <= 1, 'Found more than one process-related schema', {
    schemaIds,
  });
  return length === 0 ? null : processRelatedSchemaIds[0];
}
